import fetchApi from 'components/utils/fetch_api'

const securityQuestions = userId => {
  return fetchApi('accounts/public/secret_questions')
}

export { securityQuestions }
